export default function getFreshSideObject(){return{top:0,right:0,bottom:0,left:0};}